module.exports = __webpack_public_path__ + "img/img-8.df0639d.jpg";